import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderOpenFront: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFolderOpenFront"><Path d="M21.8457 20H2.15527L2.01953 19.4209L0.0546875 11H23.9453L21.8457 20Z" fill="currentColor"/><Path d="M12.3047 5H22V9.5H2V3H10.249L12.3047 5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderOpenFront;
